import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { AppProviders } from "@/app/providers";
import { router } from "@/app/router";
import { hydratePublishedContent } from "@/services/published-content";
import { initializeNativeAuthLinks } from "@/services/native-auth";
import "@/styles/globals.css";

const darkMode = window.matchMedia("(prefers-color-scheme: dark)");
const applyTheme = (isDark: boolean) => {
  document.documentElement.classList.toggle("dark", isDark);
};
applyTheme(darkMode.matches);
darkMode.addEventListener("change", (event) => applyTheme(event.matches));

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Rot-elementet saknas.");

await Promise.all([hydratePublishedContent(), initializeNativeAuthLinks()]);

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
